'use client'
import { tabsAnatomy } from '@chakra-ui/anatomy'
import {
  createMultiStyleConfigHelpers,
  Tab as ChakraTab,
} from '@chakra-ui/react'
import { forwardRef, LegacyRef } from 'react'

import { TabProps } from './Tab.types'

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(tabsAnatomy.keys)

const baseStyle = definePartsStyle({
  tab: {
    display: 'flex',
    flexDirection: 'column',
    _selected: { fontWeight: 'semibold' },
  },
  tabpanels: {
    overflow: 'hidden',
  },
  tabpanel: {
    padding: '0.5rem 0',
  },
})

export const TabStyle = defineMultiStyleConfig({ baseStyle })

export default forwardRef(function Tab(
  props: TabProps,
  ref: LegacyRef<HTMLButtonElement>
) {
  return <ChakraTab {...props} ref={ref} translate="no" />
})
